import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Loading from "../../../components/Loading/Loading";

const AddDoctor = () => {
  // React Hooks Form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  //   IMAGEBB API KEY
  const imagehostkey = process.env.REACT_APP_IMGBB_KEY;
  console.log(imagehostkey);

  const handleAddDoctor = (data) => {
    const image = data.photo[0];
    const formData = new FormData();

    formData.append("image", image);

    const url = `https://api.imgbb.com/1/upload?&key=${imagehostkey}`;

    fetch(url, {
      method: "POST",
      //As we are sending image file we won't use JSON.stringify
      body: formData,
    })
      .then((res) => res.json())
      .then((imgData) => {
        if (imgData.success) {
          const imgDirectLink = imgData.data.url;
          console.log("Image Data", imgData);
          const doctor = {
            name: data.name,
            email: data.email,
            speciality: data.specialty,
            image: imgDirectLink,
          };

          //   Save doctor information to the database
          fetch("https://doctors-portal-server-azure.vercel.app/doctors", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "Bearer " + localStorage.getItem("doctors_token"),
            },
            body: JSON.stringify(doctor),
          })
            .then((res) => res.json())
            .then((result) => {
              if (result.acknowledged) {
                // Show Conformation and reset form fields
                toast.success(data.name + " is added successfully");
                navigate("/dashboard/managedoctors");
                reset();
              }
            });
        }
      });
  };

  //   TenStack Query
  const { data: specialities, isLoading } = useQuery({
    queryKey: ["speciality"],
    queryFn: async () => {
      const res = await fetch(
        "https://doctors-portal-server-azure.vercel.app/appointmentSpeciality"
      );
      const data = res.json();
      return data;
    },
  });

  if (isLoading) {
    return <Loading />;
  }

  return (
    <section className="bg-[#F1F5F9] px-14 py-7 min-h-screen">
      <div className="flex justify-center items-center h-screen">
        <div className="min-w-[380px] p-7 shadow bg-white">
          <h2 className="text-xl font-medium my-5">Add doctor</h2>
          <form
            onSubmit={handleSubmit(handleAddDoctor)}
            className="grid gap-4 "
          >
            {/* Name Field */}
            <div className="form-control w-full ">
              <label htmlFor="name">Name</label>
              <input
                id="name"
                type="name"
                placeholder="Enter Your Name"
                className="input input-bordered w-full max-w-xs"
                {...register("name", { required: "Name is required" })}
              />
              {errors.name && (
                <p role="alert" className="mt-2 text-red-800 text-sm ml-1">
                  {errors.name?.message}
                </p>
              )}
            </div>
            {/* Email Field */}
            <div className="form-control w-full ">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                placeholder="Email"
                className="input input-bordered w-full max-w-xs"
                {...register("email", { required: "Email is required" })}
              />
              {errors.email && (
                <p role="alert" className="mt-2 text-red-800 text-sm ml-1">
                  {errors.email?.message}
                </p>
              )}
            </div>
            {/* Select Speciality Field */}
            <div className="form-control w-full ">
              <label htmlFor="speciality">Pick a Speciality</label>
              <select
                name="speciality"
                id="speciality"
                defaultValue="wtf"
                className="select select-bordered w-full max-w-xs"
                {...register("specialty")}
              >
                <option disabled>Please Select a Speciality</option>
                {specialities.map((speciality) => (
                  <option key={speciality._id} value={speciality.name}>
                    {speciality.name}
                  </option>
                ))}
              </select>
            </div>
            {/* Photo Field */}
            <div className="form-control w-full ">
              <label htmlFor="photo">Profile Picture</label>
              <input
                id="photo"
                type="file"
                className="input input-bordered w-full max-w-xs"
                {...register("photo", { required: "Please upload an image" })}
              />
              {errors.photo && (
                <p role="alert" className="mt-2 text-red-800 text-sm ml-1">
                  {errors.photo?.message}
                </p>
              )}
            </div>

            <input
              type="submit"
              value="Add Doctor"
              className="btn w-full my-2"
            />
          </form>
        </div>
      </div>
    </section>
  );
};

export default AddDoctor;
